export default __webpack_public_path__ + "locales/zh-CN/SingleSignOn.json?hash=8e280bf8fda4f72b0d7c7a7e7bc81757";